export default {
  inline: true,
  group: "inline",
  content: "inline*",
  toDOM: () => ["span", { class: "inline-container" }, 0],
  parseDOM: [{ tag: "span.inline-container" }],
};
